<template>
  <div v-if="this.isLoading === true">
    <base-spinner></base-spinner>
  </div>
  <div v-else class="table">
    <div class="table-header">
      <p>Tài liệu</p>

      <select class="w3-select w3-border" v-model="filterCategory">
        <option value="" disabled selected>Chọn danh mục</option>
        <option value="">Tất cả</option>
        <option v-for="mc in getDCSelectFilter" :key="mc.id" :value="mc.id">
          {{ mc.name }}
        </option>
      </select>

      <select class="w3-select w3-border" v-model="filterDocument">
        <option value="" disabled selected>Chọn loại</option>
        <option value="">Tất cả</option>
        <option value="word">Word</option>
        <option value="pdf">PDF</option>
        <option value="excel">Excel</option>
        <option value="ppt">PowerPoint</option>
        <option value="archive">Archive</option>
      </select>

      <div>
        <input v-model="filterTerm" placeholder="Tên file" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px; margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button @click="addClick" class="add-new" v-if="$checkPermission('create_document')">+ Thêm mới</button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên file</th>
            <th>Loại</th>
            <th>Mô tả</th>
            <th>Loại</th>
            <th>Đuôi File</th>
            <th>Ẩn</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in paginatedData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.fileName }}</td>
            <td>
              <!-- <a :href="ctt.filePath" :download="`${ctt.fileName}${ctt.fileExtension}`" target="_blank"> -->
              <a href="#" @click.prevent="downloadFile(ctt.filePath, ctt.fileName, ctt.fileExtension)">
                <img @contextmenu.prevent :src="require(`../../../assets/fileType/${getFileType (ctt.fileExtension)}`)">
              </a>
            </td>
            <td>{{ ctt.fileDescription }}</td>
            <td>{{ showDocumentCategory(ctt.categoryId) }}</td>
            <td>{{ ctt.fileExtension }}</td>
            <td>{{ ctt.isHidden }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_document')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_document')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>

  </div>

  <!-- modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal" size="large">
    <div>
      <div class="site-box">
        <div class="first-site">
          <div class="data-display">
            <div class="box"> <p>Tên file</p> </div>
            <input type="text" v-model="fileName"/>
          </div>

          <div class="data-display">
            <div class="box"> <p>Ngôn ngữ</p> </div>
            <select v-model="lang">
              <option value="vn">vn</option>
              <option value="en">en</option>
              <option value="all">Tất cả</option>
            </select>
          </div>

          <div class="data-display">
            <div class="box"> <p>Loại</p> </div>
            <select v-model="categoryId">
              <option disabled value="">Chọn loại</option>
              <option v-for="mc in getDCSelect" :key="mc.id" :value="mc.id">
                {{ mc.name }}
              </option>
            </select>
          </div>

          <div class="data-display">
            <div class="cb-box"> <p>Ẩn<span style="color: red;">*</span></p> </div>
            <div>
              <label>
                <input id="cb" type="checkbox" :checked="isHidden === true" v-model="isHidden" :true-value="true" :false-value="null" />
                Có
              </label>

              <label>
                <input id="cb" type="checkbox" :checked="isHidden === false" v-model="isHidden" :true-value="false" :false-value="null" />
                Không
              </label>
            </div>
          </div>

        </div>
        <div class="second-site">
          <div>
            <div>
              <a>
                <img @contextmenu.prevent :src="require(`../../../assets/fileType/${getFileType (fileExtension)}`)" style="width: 80px; height: 72px;">
              </a>
            </div>
            <input type="file" @change="changeFile" ref="fileInput" style="margin: 10px 0px;">
          </div>

          <!-- <div class="data-display">
            <div class="box"> <p>Is Hidden</p> </div>
            <select v-model="isHidden">
              <option :value="true">true</option>
              <option :value="false">false</option>
            </select>
          </div> -->
        </div>
      </div>
      <div class="data-display">
        <div class="ebox"> <p>Mô tả</p> </div>
        <textarea v-model="fileDescription"></textarea>
      </div>
    </div>

    <div class="btn-container">
      <button type="button" :disabled="isClicked" v-if="id === 0" @click="createClick()">Tạo</button>
      <button type="button" :disabled="isClicked" v-if="id !== 0" @click="updateClick()">Cập nhật</button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    @delete="deleteClick(selectedId)"></alert-modal>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      fileUpload: '',
      pageSize: 6,
      currentPage: 1,
      isValid: true,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      filterTerm: '',
      appliedTerm: '',
      filterCategory: '',
      filterDocument: '',
      selectedId: 0,
      isLoading: false,
      isClicked: false,
      // data
      id: 0,
      document: '',
      fileName: '',
      fileDescription: '',
      categoryId: 0,
      lang: 'vn',
      fileExtension: '',
      createdAt: '',
      author: '',
      updatedAt: '',
      isHidden: false,
      propertiesToCheck: ['categoryId', 'fileUpload', 'isHidden']
    }
  },
  computed: {
    getDocument () {
      return this.$store.getters['documents/backendDocument']
    },
    filterItems () {
      if (!this.appliedTerm && !this.filterCategory && !this.filterDocument) {
        return this.getDocument
      }
      this.reloadPageWithFilter()
      const searchTerm = this.appliedTerm.toLowerCase()
      const searchNumber = Number(this.filterCategory)

      // eslint-disable-next-line
      let data = this.getDocument.filter(data => data.categoryId.toString() === searchNumber.toString())

      // Chi search ten
      if (data.length === 0 && !this.filterCategory && !this.filterDocument) {
        return this.getDocument.filter(data => data.fileName.toLowerCase().includes(searchTerm))
      } else if (data.length === 0 && !this.filterCategory && this.filterDocument) {
        data = this.getDocument
      }

      // const filterMapping = {
      //   pdf: ['.pdf'],
      //   excel: ['.xlsx'],
      //   ppt: ['.pptx'],
      //   word: ['.docx', '.doc'],
      //   archive: ['.rar', '.zip'],
      // };

      // if (this.filterDocument in filterMapping) {
      //   data = data.filter(item => filterMapping[this.filterDocument].includes(item.fileExtension));
      // }

      if (this.filterDocument === 'pdf') {
        data = data.filter(data => data.fileExtension === '.pdf')
      } else if (this.filterDocument === 'excel') {
        data = data.filter(data => data.fileExtension === '.xlsx')
      } else if (this.filterDocument === 'ppt') {
        data = data.filter(data => data.fileExtension === '.pptx')
      } else if (this.filterDocument === 'word') {
        data = data.filter(data => data.fileExtension === '.docx' || data.fileExtension === '.doc')
      } else if (this.filterDocument === 'archive') {
        data = data.filter(data => data.fileExtension === '.rar' || data.fileExtension === '.zip')
      }

      return data.filter(data => data.fileName.toLowerCase().includes(searchTerm))
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filterItems.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.filterItems.length / this.pageSize)
      if (tp === 0) return 1
      return tp
    },
    getDCSelect () {
      return this.$store.getters['documents/selectDocumentCategory'](this.lang)
    },
    getDCSelectFilter () {
      return this.$store.getters['documents/selectDocumentCategoryFilter']
    }
  },
  methods: {
    sendFilterTerm () {
      this.appliedTerm = this.filterTerm
    },
    showDocumentCategory (id) {
      return this.$store.getters['documents/showDocumentCategory'](id)
    },
    getFileType (type) {
      if (type === '.pdf') return 'pdf.png'
      else if (type === '.xlsx') return 'excel.png'
      else if (type === '.docx' || type === '.doc') return 'word.png'
      else if (type === '.pptx') return 'powerpoint.png'
      else if (type === '.rar' || type === '.zip') return 'rar.png'
      else return 'document.png'
    },
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    changeFile (event) {
      this.fileUpload = event.target.files[0]
      if (this.fileUpload) {
        this.document = URL.createObjectURL(this.fileUpload)
        this.fileExtension = '.' + this.fileUpload.name.split('.').pop().toLowerCase()
      }
    },
    toggleModal () {
      this.modalActive = !this.modalActive
      const video = this.$refs.modalVideo
      if (video) {
        video.load() // Reload the video to reset it completely
      }
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    async getDocumentData () {
      this.isLoading = true
      await this.$store.dispatch('documents/getDocumentCategoriesData')
      await this.$store.dispatch('documents/getDocumentData')
      this.isLoading = false
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if (this[key] === '') {
          this.isValid = false
        }
      })
    },
    async downloadFile (url, name, extension) {
      try {
        // Fetch file with authentication
        const response = await axios.get(url, {
          responseType: 'blob', // Get binary data
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        })

        // Create a Blob URL
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]))

        // Create a temporary link and trigger download
        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute('download', name + extension) // Set file name
        document.body.appendChild(link)
        link.click() // Trigger download

        // Cleanup
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
      } catch (error) {
        console.error(`Error downloading ${name}:`, error)
        this.$showError('Đã xảy ra lỗi không mong muốn')
      }
    },
    addClick () {
      this.isClicked = false
      this.isValid = true
      this.modalTitle = 'Thêm tài liệu'
      this.$refs.fileInput.value = null
      this.id = 0
      this.document = ''
      this.fileName = ''
      this.fileDescription = ''
      this.categoryId = ''
      this.lang = 'vn'
      this.createdAt = ''
      this.author = 'admin'
      this.updatedAt = ''
      this.fileUpload = ''
      this.isHidden = false
      this.fileExtension = ''
      this.toggleModal()
    },
    async createClick () {
      this.isClicked = true
      this.validateVariable()
      if (!this.isValid) {
        this.isClicked = false
        this.$showError('Hãy chọn file và điền đủ thông tin cần thiết để tiếp tục')
        return
      }

      const newDocument = {
        file: this.fileUpload,
        fileName: this.fileName,
        categoryId: this.categoryId,
        fileDescription: this.fileDescription,
        author: this.author,
        lang: this.lang,
        isHidden: this.isHidden
      }

      try {
        await this.$store.dispatch('documents/postDocument', newDocument)
        this.$showSuccess('Tạo thành công')
        this.getDocumentData()
        this.toggleModal()
      } catch (error) {
        this.isClicked = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    editClick (data) {
      this.isClicked = false
      this.isValid = true
      this.toggleModal()
      this.modalTitle = 'Chỉnh sửa tài liệu'
      this.fileUpload = ''
      this.$refs.fileInput.value = null
      this.id = data.id
      this.document = data.filePath
      this.fileName = data.fileName
      this.fileDescription = data.fileDescription
      this.categoryId = data.categoryId
      this.lang = data.lang
      this.isHidden = data.isHidden
      this.createdAt = data.createdAt
      this.author = data.author
      this.updatedAt = data.updatedAt
      this.fileExtension = data.fileExtension
    },
    async updateClick () {
      this.isClicked = true

      if (this.isHidden === null || this.isHidden === '') {
        this.isClicked = false
        this.$showError('Thiếu thông tin cần thiết')
        return
      }

      const updatedDocument = {
        id: this.id,
        file: this.fileUpload,
        fileName: this.fileName,
        categoryId: this.categoryId,
        fileDescription: this.fileDescription,
        author: this.author,
        lang: this.lang,
        isHidden: this.isHidden
      }

      try {
        await this.$store.dispatch('documents/updateDocument', updatedDocument)
        this.$showSuccess('Cập nhật thành công')
        this.getDocumentData()
        this.toggleModal()
      } catch (error) {
        this.isClicked = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    async deleteClick (id) {
      await this.$store.dispatch('documents/deleteDocument', id)
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (this.filterItems.slice(start, end).length === 1 && this.currentPage > 1) {
        this.currentPage--
      }
      this.toggleAlert()
      this.getDocumentData()
    }
  },
  async mounted () {
    await this.getDocumentData()
  }
}

</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: 1px solid #0298cf;
    color: #0298cf;
  }

  .table-header select {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  /* sua */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  /* Sua */
  td img {
    max-height: 60px;
    max-width: 60px;
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 15px;
    border: 3px solid #ced0d2;
  }

  td video {
    max-height: 60px;
    max-width: 60px;
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 15px;
    border: 3px solid #ced0d2;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  tr:nth-child(even) {background-color: #ececec }

  td:nth-child(1) {
    width: 70px;
    text-align: center;
  }

  td:nth-child(3) {
    text-align: center;
    width: 110px;
  }

  /* th:nth-child(9), td:nth-child(9) {
    text-align: center;
    width: 120px;
  } */

  th:nth-child(8), td:nth-child(8) {
    text-align: center;
    width: 120px;
  }

  th:nth-child(7), td:nth-child(7) {
    text-align: center;
    width: 100px;
  }

  th:nth-child(6), td:nth-child(6) {
    text-align: center;
    width: 100px;
  }

  th:nth-child(5), td:nth-child(5) {
    text-align: center;
    width: 200px;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 20px;/* Sua */
    /* border: 2px solid #000; */
  }

  .data-display .box {
    width: 120px;
  }

  .data-display .cb-box {
    width: 100px;
  }

  .data-display .ebox {
    width: 110px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }

  .data-display #cb {
    height: 12px;
    width: auto;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
    margin-right: 10px;
  }

  .data-display label {
    margin-right: 80px;
  }

  .data-display #special-label {
    margin-right: 66px;
  }

  #items {
    justify-content: space-between;
  }

  .data-display-s {
    display: flex;
    align-items: center;
  }

   .data-display-s select{
    margin-left: 24px;
  }

  .outsite > .data-display {
    display: block;
  }

  textarea {
    margin-top: 5px;
    height: 55px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 5px;
  }

  .site-box {
    display: flex;
  }

  .first-site {
    flex: 1;
  }

  .second-site {
    width: 305px;
    padding-left: 45px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-container button {
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .errors {
    font-weight: bold;
    color: red;
  }
</style>
